import React from "react";
import { FormikFormWrapperForJetpackConfig } from "../FormikForm/FormikFormWrapperForJetpackConfig";
import JetpackPrizesConfig from "./JetpackGiftConfig";
import prize_validation_schema from "./helper/prize_validation_schema";

const PrizesConfigWrapper = () => {
  return (
    <FormikFormWrapperForJetpackConfig
      validationSchema={prize_validation_schema}
      ChildComponent={JetpackPrizesConfig}
      redirectTargetAfterSubmit="/configuration/prizes"
    />
  );
};

export default PrizesConfigWrapper;
